module.exports = __webpack_public_path__ + "static/media/call-made.496c5b93.svg";